import { render, staticRenderFns } from "./PythonList.vue?vue&type=template&id=ecab81c2&scoped=true&"
import script from "./PythonList.vue?vue&type=script&lang=js&"
export * from "./PythonList.vue?vue&type=script&lang=js&"
import style0 from "./PythonList.vue?vue&type=style&index=0&id=ecab81c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecab81c2",
  null
  
)

export default component.exports